import styles from './login2.module.css';

// The React Functional Component
export const Login2 = () => {
  // You would handle the password visibility state and form submission here

  return (
    // Wrapper and Layout Containers (similar to LoginSplit)
    <div className={`${styles.root} light`}>
      <div className={styles.container}>
          {/* Left Column: Image */}
     
        
        {/* right Column: Form Content */}
        <div className={styles.formSection}>
          <div className={styles.formWrapper}>
            
         
            
            <main className={styles.mainContent}>
              <div className={styles.titleGroup}>
                <p className={styles.title}>Create Your Account</p>
                <p className={styles.subtitle}>Start planning your next adventure today.</p>
              </div>
              
              <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
                
                {/* Full Name Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Full Name</p>
                  <input className={styles.input} placeholder="e.g., Alex Doe" type="text" defaultValue="" />
                </label>
                
                {/* Email Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Email Address</p>
                  <input className={styles.input} placeholder="e.g., alex.doe@example.com" type="email" defaultValue="" />
                </label>
                
                {/* Password Field */}
                <label className={styles.formGroup}>
                  <p className={styles.label}>Password</p>
                  <div className={styles.inputStretchWrapper}>
                    <input 
                      className={styles.passwordInput} 
                      placeholder="Enter a secure password" 
                      type="password" 
                      defaultValue="" 
                    />
                    <div className={styles.passwordIconWrapper}>
                      {/* Note: The original HTML showed 'visibility' which means visible, so I've kept it as is */}
                      <span className="material-symbols-outlined text-xl">visibility</span>
                    </div>
                  </div>
                </label>
                
              
                
                {/* Submit Button */}
                <button className={styles.registerButton} type="submit">
                  <span className={styles.buttonText}>Create Account</span>
                </button>
              </form>
              
              {/* Sign In Link */}
              <p className={styles.signInText}>
                Already have an account? <a className={styles.signInLink} href="#">Sign In</a>
              </p>
            </main>

          </div>
        </div>

      
        
      </div>
    </div>
  );
};